import Swiper, {Autoplay, Pagination} from 'swiper';

const Values = () => {
  window.values = new Swiper('.js-values', {
    modules: [Autoplay, Pagination],
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 1000,
    slidesPerView: 1,
    pagination: {
      el: '.js-values-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        const objects = JSON.parse(this.el.dataset.pagination) || [];
        return '<div class="values__item ' + className + '"><div class="values__title">' + objects[index].title + '</div><div class="values__progress"></div><div class="values__text">' + objects[index].text + '</div></div>';
      },
    }
  });
}

export default Values;
